import axios from 'axios'
import { Modal } from 'ant-design-vue'
import store from '@/store'
import { getToken } from './auth'
import De  from 'crypto-js'
import Cookies from 'js-cookie'
const global  = require("../../static/global")
var lock = true;
// function DeData(ciphertext) {
//   var keyHex = De.enc.Utf8.parse(process.env.VUE_APP_ZLT_MMM);
//   var ivHex = De.enc.Utf8.parse(process.env.VUE_APP_ZLT_MMM);
//   // direct decrypt ciphertext
//   var decrypted = De.DES.decrypt({
//     ciphertext: De.enc.Base64.parse(ciphertext)
//   }, keyHex, {
//     iv: ivHex,
//     mode: De.mode.ECB,
//     padding: De.pad.Pkcs7
//   });
//   return decrypted.toString(De.enc.Utf8);
// }
// 创建 axios 实例
// console.log(process,'process',window.returnCitySN.cip)
const service = axios.create({
  baseURL: '/dev' + '/api', // global.BaseApi
  // baseURL:  global.BaseApi, 192.168.10.252:8000
  withCredentials: true, // 跨域请求时发送 cookies
  timeout: 180000 // 指定请求超时的毫秒数(0 表示无超时时间)
})

function getQueryVariable(variable){
  // console.log(window.location.origin,'域名沙虎鲨',global.loginPath,window.location,global.tasPath,global.cookiePath);

  if(window.location.origin == global.srmPath){
    var token  = Cookies.get('app.token',{domain:global.cookiePath})
    if(token){
      return token
    }
  }
  if(window.location.origin == global.tasPath){
    var token  = Cookies.get('app.token_TAS',{domain:global.cookiePath})
    if(token){
      return token
    }
  }
  if(window.location.origin == global.dasPath){
    var token  = Cookies.get('app.token_DAS',{domain:global.cookiePath})
    if(token){
      return token
    }
  }
  if(window.location.origin == global.loginPath){
    var token  = Cookies.get('app.token',{domain:global.cookiePath})
    if(token){
      return token
    }

  }
  // 小程序 webView跳转测试用
  if(window.location.origin.split('170:')[1] == global.loginPath.split('localhost:')[1]){
    var token  = Cookies.get('app.token',{domain:global.cookiePath})
    console.log('master_______________token',token);
    if(token){
      return token
    }
  }

  // var query = window.location.search.substring(1);
  // var vars = query.split("&");
  // for (var i=0;i<vars.length;i++) {
    // var pair = vars[i].split("=");
    // if(pair[0] == variable){return pair[1];}
  // }
  // Cookies
  return(false);
}

function getQueryVariableSystemtype(variable){
  // console.log(window.location.origin,'域名沙虎鲨',window.location,global.tasPath,global.cookiePath);
  // console.log(Cookies.get('app.token_TAS'))
  // console.log( Cookies.get('app.token_TAS',{domain:global.cookiePath}))
  if(window.location.origin == global.srmPath){
    return 'srm'
  }
  if(window.location.origin == global.tasPath){
    return 'tas'
  }
  if(window.location.origin == global.dasPath){
    return 'das'
  }
  if(window.location.origin == global.loginPath){
    return ''
  }

  // var query = window.location.search.substring(1);
  // var vars = query.split("&");
  // for (var i=0;i<vars.length;i++) {
    // var pair = vars[i].split("=");
    // if(pair[0] == variable){return pair[1];}
  // }
  // Cookies
  return(false);
}


// 请求拦截器
service.interceptors.request.use(
  
  config => {
    // 默认增加系统Key
    
    
      config.headers['Author'] = getQueryVariable('token') ? getQueryVariable('token') : "";
      config.headers['token'] = getQueryVariable('token') ? getQueryVariable('token') : "";
      config.headers['systemtype'] = getQueryVariableSystemtype() ? getQueryVariableSystemtype() : "";
      config.headers['Access-Control-Allow-Origin'] = "*";
      // config.headers['Content-Security-Policy'] ='upgrade-insecure-requests';
      // config.headers['localIp'] = window.returnCitySN.cip
      if(config.headers['systemtype']==''&&window.location.hash=='#/'){
        config.headers['token'] = "";
      }
      // return 
      if(config.url.indexOf('/auth/personal/queryIndexUrl')!=-1){

        let type = config.url.split('?systemType=')[1]
        if(Number(type)==1){
          config.headers['token'] = Cookies.get('app.token',{domain:global.cookiePath});
        }else{
          config.headers['token'] = Cookies.get('app.token_TAS',{domain:global.cookiePath});
        }
      }

      if(config.url.indexOf('/auth/account/tipsSearch')!=-1){
        let type = config.params.systemType;
        if(Number(type)==1){
          config.headers['token'] = Cookies.get('app.token',{domain:global.cookiePath});
        }else{
          config.headers['token'] = Cookies.get('app.token_TAS',{domain:global.cookiePath});
        }
      }
      
      if(config.url.indexOf('/auth/account/bindingWeChat')!=-1){
        let type = config.params.initial;
        if(Number(type)==1){
          config.headers['token'] = Cookies.get('app.token',{domain:global.cookiePath});
        }else{
          config.headers['token'] = Cookies.get('app.token_TAS',{domain:global.cookiePath});
        }
      }

      // config.headers['token'] = "a0b0d237-87fe-4221-9ece-6180c66d9d70"

      // 发送前准备
      if (store.getters.token) {
        // 让每个请求携带令牌
        config.headers.Authorization = getToken()
      }
      return config
  },
  error => {
    console.log('请求拦截出错')
    // 处理请求错误
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  /**
   * 通过自定义代码确定请求状态
   * 您还可以通过HTTP状态代码判断状态
   */
  response => {
    const res = response.data
    if (res.code != 200) {
      // console.log(res,"11111122222")

      switch (res.code) {
        case 401:
        alert("登陆授权已过期")
        window.location.href = global.loginPath
        // return Promise.reject(res.Message || '请求错误')
          break;
      }
      return res
    } else {
    return res
      if (res.IsSucceed) {
        if(res.Entity){
          try {
            // res.Entity = JSON.parse(DeData(res.Entity))
            res.Entity = JSON.parse(res.Entity)
          } catch (error) {

          }
        }
        return { data: res.Entity }
      }
      return Promise.reject(res.Message || '请求错误')
    }
  },
  error => {
    // console.log(error.response.data,'eror')
      // return
      var query = window.location.hash;
      let that = this;
      if(query){
        query= query.split('?')[1]
        if(query){
          let obj = query.split('=')
          if(obj[0] == 'ruzhu'){
              return
          }

        }
      }
    if (error.response) {
      if(error.response.data.code == 401){
        // alert("登陆授权已过期，请重新登录")
        // window.location.href = "http://localhost:7000"
        if(lock){
          lock = false
          Modal.warning({title:'提示',content:error.response.data.message,centered:true,onOk:()=>{
            if(window.location.origin == global.dasPath){
              window.location.href = global.dasPath+"/#/login"
              lock = true
              return
            }
            window.location.href = global.loginPath
            lock = true
          }})

        }
      } else {
        return Promise.reject(error.response.data) //返回接口返回的错误信息
      }

    }
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js